import $ from "dabbyjs/src/core/dabby/dabby.js";
import tagging from "./tagging.js";

export default () => {
	tagging($("fieldset[data-tags]"));
};